import React, {useEffect, useState} from "react"
import {useSelector} from "react-redux"
import {DateTime} from "luxon"
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid2"
import QueueNumber from "./QueueNumber"
import {ServiceCardType} from "../Types"
import {useTranslation} from "react-i18next"
import BackButton from "../Common/BackButton"
import TakeQueueNumberButton from "./TakeQueueNumberButton"
import api from '../../../Services/api'
import {RootState} from '../../../Redux'

const { postFindAvailableTimeSpecial } = api.create();

const NOTICE_WAIT_TIME_THRESHOLD = 60 * 60 * 1000 // 1 hour

interface SpecialInspectionProps {
    onBack: () => void
    queueType: string
}

const SpecialInspection = ({onBack, queueType}: SpecialInspectionProps) => {
    const { t } = useTranslation()

    const chainId = useSelector((state: RootState) => state.ui?.settings?.chain?.id)
    const stationId = useSelector((state: RootState) => state.ui?.settings?.station?.id)

    const [queueNumber, setQueueNumber] = useState<number|null>(null)
    const [serviceCard, setServiceCard] = useState<ServiceCardType>()
    const [nextAvailableTimeAt, setNextAvailableTimeAt] = useState<string|null>(null)

    useEffect(() => {
        if (chainId && stationId && queueType) {
            postFindAvailableTimeSpecial(chainId, stationId, queueType).then((data) => {
                const nextAvailableTime = (data.data ?? '') !== '' ? DateTime.fromISO(data.data as string) : null
                setNextAvailableTimeAt(nextAvailableTime?.diffNow()?.milliseconds > NOTICE_WAIT_TIME_THRESHOLD ? nextAvailableTime.minus({minutes: nextAvailableTime.minute % 15}).toFormat('HH:mm') : null)
                if (!nextAvailableTime) {
                    setQueueNumber(-1)
                }
            })
        }
    }, [chainId, stationId, queueType, setNextAvailableTimeAt]);

    return (<>
        {queueNumber === null && <>
            <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className={"pageMainContainer"}>
                <Grid>
                </Grid>
                <Typography variant="h4">
                    {t('selfService.specialInspectionCustomersAreServedByQueueNumber')}
                </Typography>
                <TakeQueueNumberButton
                    queueType={queueType}
                    setServiceCard={setServiceCard}
                    setQueueNumber={setQueueNumber}
                />
                <Grid>
                    {nextAvailableTimeAt ? <div className="contentWithMargin">
                        <Typography variant="body1" color="error">Huom! Seuraava vapaa aika on noin kello {nextAvailableTimeAt}</Typography>
                    </div> : null}
                </Grid>
                <Grid className="footerButtons">
                    <Grid container spacing={4} justifyContent="space-between" alignItems="end">
                        <Grid>
                            <BackButton onBack={onBack} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>}
        {queueNumber !== null &&
            <QueueNumber serviceCard={serviceCard} queueNumber={queueNumber}/>
        }
    </>)
}

export default SpecialInspection
